module.exports = __webpack_public_path__ + "img/محصول.86c08f7a.jpg";